import React, { PropsWithChildren, useContext } from "react";
import { twMerge } from "tailwind-merge";

import { TabContext } from "./TabContext";

export interface TabPanelProps extends PropsWithChildren {
  activeValue?: string | number;
  value?: string | number;
  unmountOnExit?: boolean;
  className?: string;
}

export function SupTabPanel({ value, activeValue, unmountOnExit = false, className, children }: TabPanelProps) {
  const { activeTab } = useContext(TabContext);

  const currentValue = activeValue ?? activeTab;
  const isVisible = value === currentValue;

  if (unmountOnExit && !isVisible) {
    return null;
  }

  return <div className={twMerge("sup-tab-panel", !isVisible && "hidden", className)}>{children}</div>;
}
